<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="Chapter1">
<p class="centerImage"><img alt="images" id="pg_15_1" src="images/pg_15_1.jpg"/></p>
<p class="caption">Hitler’s Blitzkrieg through northern France in May 1940 proved unstoppable, as this wrecked Char B1 tank testifies; the swift defeat of the French Army that summer gave Mussolini a free hand to attack British interests in North Africa. (<em class="italic">Author’s Collection</em>)</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_02_Chapter1.vue?2db29c64